<template>
  <div id="page-company-address-edit">
    <user-addresses
        v-if="model"
        ref="form"
        v-model="model"
        :loading="loading"
        title="Edit Address"
        subtitle=" "
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              class="my-4"
              @click="$router.push({ name: 'contact.addresses.list'})"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              class="my-4"
              color="light"
              @click="save"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CardPage from '../../../components/Views/CardPage';
import UserAddresses from '../forms/UserAddresses';
import SaveModelMixin from '../../../../components/mixins/SaveModelMixin';
import ViewModelMixin from '../../../../components/mixins/ViewModelMixin';
import NotificationMixin from '../../../../components/mixins/NotificationMixin';

export default {
  components: {
    CardPage,
    UserAddresses,
  },
  mixins: [ViewModelMixin, SaveModelMixin, NotificationMixin],
  data () {
    return {
      loading: false,
      modelEntity: this.$api.companyAddress,
    }
  },
  methods: {
    async fetch() {
      try {
        const { data } = await this.$api.users.getAddress(
            this.$route.params.id,
            this.$route.params.addressId
        );

        this.model = data.data;

      } catch (e) {
        console.log(e);
        this.$vs.notify({
          title: 'Error occurred',
          text: 'Not able to retrieve address details. Please try again.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      } finally {
        if (!this.data || this.data.Company_FK !== this.$route.params.id) {
          this.address_not_found = true
        }
      }
    },
    getParams() {
      const params = this.getModelCopy(true);

      const references = [
          'AddressType_FK',
      ];

      this.setReferences(references);

      return params;
    },
    validate() {
      return this.$refs.form.validate();
    },
    async save() {
      if (!this.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();

      try {
        const {data} = await this.$api.users.updateAddress(
            this.$route.params.id,
            this.$route.params.addressId,
            params
        );

        this.notifySuccess('Address updated');
        this.$router.back();
      } catch (e) {
        this.notifyError('Address failed to be updated');
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>
